import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-image-simple',
  templateUrl: './card-image-simple.component.html',
  styleUrls: ['./card-image-simple.component.css']
})
export class CardImageSimpleComponent implements OnInit {

  @Input() cardInfo;

  constructor() { 
    this.cardInfo && !this.cardInfo.imageUrl? this.cardInfo.imageUrl = '../../assets/img/cards/1.jpg' : null;
  }

  ngOnInit(): void {
  }

}
